import { GetLoadables } from './loader';
// #if process.env.UIX_CHUNKED === 'true'
let loader = ()=>{
    // only used in markdown context - share chunk
    return import(/* webpackChunkName: 'markdown' */ './prismLoad');
};
const L = GetLoadables(loader, [
    'Highlight'
]);
// #endif
// #if process.env.UIX_CHUNKED === 'false'
// import * as L from './prismLoad'
// #endif
export let { Highlight } = L;
